export var IdCookies;
(function (IdCookies) {
    IdCookies["JourneyHash"] = "journeyHash_funnel";
})(IdCookies || (IdCookies = {}));



//////////////////
// WEBPACK FOOTER
// ./src/constants/IdCookies.ts
// module id = 1686
// module chunks = 3